import {Modal, Typography} from 'antd';
import Button from 'components/button/Button';
import { IconCancel } from 'components/icons'

interface IProps {
  isOpen: boolean,
  setModal: (value: boolean) => void,
  updateOrderStatus: () => void,
  isLoadingUpdateOrderStatus: boolean
}

const OrderConfirmationModal = (props: IProps) => {

  const {isOpen, setModal, updateOrderStatus, isLoadingUpdateOrderStatus} = props

  return (
    <Modal
      open={isOpen}
      footer={null}
      onCancel={() => setModal(false)}
      centered
      className="modal-orders-status-confirmation"
      closeIcon={<IconCancel strokeWidth="2" color="black" />}
    >
      <div className="flex flex-col">
        <Typography.Paragraph className="mb-5 text-lg font-semibold leading-5 text-gray-700">
          Apakah Anda yakin ingin menyelesaikan pesanan ini?
        </Typography.Paragraph>
      </div>
      <div className="flex flex-col">
        <Typography.Paragraph className="text-sm text-gray-500 mb-5">
          Pastikan produk yang diserahkan ke Pembeli sesuai dengan produk yang ada di daftar pesanan.
          Pastikan barang telah diterima dengan baik oleh pembeli.
          Barang yang telah diserahkan tidak dapat dikembalikan.
        </Typography.Paragraph>
      </div>
      <div className="flex gap-2">
        <Button
          block={true}
          onClick={() => setModal(false)}
          data-testid="btn_cancel"
          className="inline-block uppercase text-primary font-bold border border-primary"
          label="Batalkan"
        />
        <Button
          disabled={isLoadingUpdateOrderStatus}
          loading={isLoadingUpdateOrderStatus}
          block={true}
          onClick={updateOrderStatus}
          data-testid="btn_accept"
          className="inline-block uppercase font-bold"
          iconPosition="right"
          label="konfirmasi"
          variant="solid-primary"
        />
      </div>
    </Modal>)
}

export default OrderConfirmationModal
